<template>
  <div>
    <div class="link" @click="toggle(model)" :class="[model.level == '1' ? 'accordion-top-level' : '', model.opened ? 'focus': '', model.active ? 'byl-accordion-active' : '']">
      {{ model.name }}
      <i class="fa fa-chevron-down" v-if="isFolder"></i>
    </div>
    <transition name="slide">
      <ul class="submenu" v-show="model.opened" v-if="isFolder">
        <item v-for="item in model.children" :model="item" :key="item.id" @route-changed="routeChanged"></item>
      </ul>
    </transition>
  </div>
</template>
<script>

export default {
  name: 'item',
  mounted () {
  },
  data () {
    return {
    }
  },
  computed: {
    isFolder () {
      return this.model.children && this.model.children.length
    }
  },
  methods: {
    toggle () {
      if (this.isFolder) {
        if (this.model.active == true) { // 如果是高亮状态的话，不能关闭菜单
          this.model.opened = true
        } else { // 非高亮状态下，打开菜单
          this.model.opened = !this.model.opened
        }
      }
      if (this.model.level >= 1) {
        this.model.active = true
      }
      if (this.model.redirectTo) { // 跳转路由
        if (!this.isAbsolutePath(this.model.redirectTo)) {
          this.$router.push(this.model.redirectTo)
        }
      }
      this.$emit('route-changed', this.model)
    },
    routeChanged (route) {
      this.$emit('route-changed', route)
    },
    isAbsolutePath (url) {
      return url.substr(0,7).toLowerCase() == "http://" || url.substr(0,8).toLowerCase() == "https://"
    }
  },
  props: ['model']
}
</script>
<style scoped>
  @import './index.css';
  .slide-enter-active {
    transition: all 0.5s ease;
    height: 52px;
    overflow-y: hidden;
  }
  .slide-leave-active {
    transition: all 0.5s ease;
    height: 0px;
    overflow-y: hidden;
  }
  .slide-enter, .slide-leave {
    height: 0px;
  }
  .byl-accordion-active.link {
    color: #ff3633;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/accordion/item.vue